import { restrictedAccess } from '@/router/middleware'

export default {
  path: '/budget-codes',
  component: () => import('@/views/admin/budget-codes/Index'),
  beforeEnter: restrictedAccess(5),
}